import React from 'react'
import AddNewEmailModel from './AddNewEmailModel';
import { EMPTY } from './Constants';

export default function OEIEditText(props) {
    const addEmail=()=>{
      props.setEmail(true);
      props.setErrors({...props.errors,error2:EMPTY})
    }
    return (
      <>
      <div>
   <div class="oe-form-field ">
   <label style={{color:'#1A1A1A',paddingLeft:'0px', display:'flex'}}class="attendee-list__label event_form__items-section__title">Email address
  {(props.selectedValue==='Event Edited') ||(props.selectedValue==='Event status changed')||(props.selectedValue==='Artifacts Issue Alert')||(props.selectedValue==='Artifacts Delivered')||(props.selectedValue==='Registration failed')? <label style={{color:'#1A1A1A'}} >Receives all</label>:<></>}
   </label>
  <div class="m" style={{fontFamily:'Roboto Flex", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif'}}>
  {
    props.allEmails&&props.allEmails.map( (email)=>(
 <div class="email_row">
  <div title={email} style={{width:'205px'}} class="overflow-ellipsis">{email}</div>
  {(props.selectedValue==='Event Edited') || (props.selectedValue==='Event status changed')||(props.selectedValue==='Artifacts Issue Alert')||(props.selectedValue==='Artifacts Delivered')||(props.selectedValue==='Registration failed')?
 <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18" height="18"><circle cx="9" cy="9" r="8" stroke="#00787a" stroke-width="1" fill="transparent"></circle><circle cx="9" cy="9" r="6" fill="#00787a"></circle></svg>:<></>}
  <button onClick={e=>props.removeEmail('all',email)} type='button' style={{ color: "#ff0000" }} class="default-button default-button--slim-edit default-button--link visible-while-hovered email-remove-label"><span>Remove</span></button>
  </div>
  ))}
    {
    props.emailList.map( (email)=>(
 <div class="email_row">
  <div title={email} style={{width:'205px'}} class="overflow-ellipsis">{email}</div>
  {(props.selectedValue==='Event Edited')|| (props.selectedValue==='Event status changed')||(props.selectedValue==='Artifacts Issue Alert')||(props.selectedValue==='Artifacts Delivered')||(props.selectedValue==='Registration failed')?
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18" height="18"><circle cx="9" cy="9" r="8" stroke="#00787a" stroke-width="1" fill="transparent"></circle></svg>:<></>}
  <button onClick={e=>props.removeEmail('notall',email)} type='button' style={{ color: "#ff0000" }} class="default-button default-button--slim-edit default-button--link visible-while-hovered email-remove-label"><span>Remove</span></button>
  </div>

  
    ))}
    <div style={{display:'flex'}}>
    <button type="button" onClick={addEmail} className={ `${props.email?'email-new email-new-active':'email-new'}`}><span style={{cursor: 'pointer'}}>+ Add Email Address</span></button>
    <AddNewEmailModel type='new'editData={props.editData} setNewData={props.setNewData}email={props.email}cancelEmailAdding={props.cancelEmailAdding}emailId={props.emailId}setEmailid={props.setEmailid}error={props.error}setError={props.setError}toggeleChecked={props.toggeleChecked}onChangeToggle={props.onChangeToggle}addEmail={props.addEmail}newData={props.newData}></AddNewEmailModel>
      </div>
   </div>
    { 
  props.error2!==EMPTY?
 <div className="oe-form-field__error">{props.error2}</div>
 :EMPTY
}
  </div>

  
        </div>
        </>

    )
}
